<!DOCTYPE html>
@if (getUserGameDiscoveryDetails$ | async; as card) {
  <mat-tab-group #matTabGroup [selectedIndex]="currentTab" class="game-mat-tab"
    >
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-label" [ngClass]="{ 'game-subtab': currentTab === 0 }">{{
          "trending.Trending" | translate
        }}</span>
      </ng-template>
      <!-- content -->
      <div class="container">
        <!-- start -->
        @if (!card || !card?.friends || !card?.friends.length) {
          <ion-card class="trending-card">
            <div class="text-wrrper">
              <ion-card-header>
                <span class="tab-title">{{ "trending.Played" | translate }}</span>
                <ion-card-subtitle>
                  <p class="sub-title">{{ "trending.Games" | translate }}</p>
                </ion-card-subtitle>
              </ion-card-header>
            </div>
            <!-- <ion-content> -->
            <div class="img-wrraper">
              <img src="../../../../assets/icon/img-icon.svg" alt="" />
              <span class="group-link">{{ "discovery.Make" | translate }} <a (click)="openCommnuityTab()"> {{
              "discovery.Group" | translate }}</a></span>
            </div>
          <!-- </ion-content> -->
        </ion-card>
      } @else {
        <ion-card class="trending-card">
          <div class="text-wrrper">
            <ion-card-header>
              <span class="tab-title">{{ "trending.Played" | translate }}</span>
              <ion-card-subtitle>
                <p class="sub-title">{{ "trending.Games" | translate }}</p>
              </ion-card-subtitle>
            </ion-card-header>
          </div>
          <ion-row class="game-slide-row">
            <swiper class="game-slider" [config]="slideOpts">
              @for (data of card?.friends | filterYoursToPlay : 2; track data; let i = $index) {
                <ng-template swiperSlide>
                  <div class="item-card-container">
                    @for (game of data; track game) {
                      <ion-row class="player-card">
                        <ion-col size="4" class="play-icon">
                          <img src="{{ game?.gameData?.game_icon_url }}" class="game-icon"
                            (click)="openGamePreview(game)" />
                            @if (game?.gameData?.game_type_id == 13 || game?.gameData?.game_type_id == 14) {
                              <div class="r-append-img adventure-pvp-icon"
                                >
                        <img class="refresh-icon" [src]="
                          game?.gameData?.game_type_id == 13
                            ? 'assets/icon/refresh-3x.png'
                            : game?.gameData?.game_type_id == 14
                            ? 'assets/icon/users.svg'
                            : ''
                        " />
                                </div>
                              }
                              <!-- <img src="assets/icon/refresh-3x.png"  class="refresh-icon"> -->
                            </ion-col>
                            <ion-col size="6">
                              <div class="game-details">
                                <div class="game-title">{{game?.gameData?.content?.[selectedLanguage]?.game_title }}</div>
                                <div class="game-sub-title">
                                  {{game?.gameData?.content?.[selectedLanguage]?.game_short_title}}
                                </div>
                                <div class="player-count">
                                  <img src="../../../../assets/icon/member-icon.svg" class="player-icon" />
                                  <span class="play-count">{{ game?.count }}</span>
                                </div>
                              </div>
                            </ion-col>
                            <ion-col class="prize" size="2" (click)="navigateToGamePage(game)">
                              <span class="prize-title">{{ "discovery.Prize" | translate }}</span>
                              <div class="prize-value">
                                <span class="value bg-{{ game?.gameData?.tier }}">{{ game?.top_prize }}</span>
                              </div>
                            </ion-col>
                          </ion-row>
                        }
                      </div>
                    </ng-template>
                  }
                </swiper>
              </ion-row>
            </ion-card>
          }
          <!-- END -->
          <!-- Vishal@pordiotracker Date 15-12-2022-->
          <!-- End Date:15-12-2022 -->
          <!-- If data Played by people you follow game are not available -->
          @if (!card || !card?.following || !card?.following.length) {
            <ion-card class="trending-card">
              <div class="text-wrrper">
                <ion-card-header>
                  <span class="tab-title">{{ "trending.Played_people$" | translate }}</span>
                  <ion-card-subtitle>
                    <p class="sub-title">{{ "trending.Games_people$" | translate }}</p>
                  </ion-card-subtitle>
                </ion-card-header>
              </div>
              <!-- <ion-content> -->
              <div class="img-wrraper">
                <img src="../../../../assets/icon/img-icon.svg" alt="" />
                <span class="group-link">{{ "trending.Games_followSomeone" | translate }} <a (click)="openCommnuityTab()">
                {{ "discovery.Group" | translate }}</a></span>
              </div>
            <!-- </ion-content> -->
          </ion-card>
        } @else {
          <ion-card class="trending-card">
            <div class="text-wrrper">
              <ion-card-header>
                <span class="tab-title">{{ "trending.Played_people$" | translate }}</span>
                <ion-card-subtitle>
                  <p class="sub-title">{{ "trending.Games_people$" | translate }}</p>
                </ion-card-subtitle>
              </ion-card-header>
            </div>
            <ion-row class="game-slide-row">
              <swiper class="game-slider" [config]="slideOpts">
                @for (data of card?.following | filterYoursToPlay : 2; track data; let i = $index) {
                  <ng-template swiperSlide>
                    <div class="item-card-container">
                      @for (game of data; track game) {
                        <ion-row class="player-card">
                          <ion-col size="4" class="play-icon">
                            <img src="{{ game?.gameData?.game_icon_url }}" class="game-icon"
                              (click)="openGamePreview(game)" />
                              @if (game?.gameData?.game_type_id == 13 || game?.gameData?.game_type_id == 14) {
                                <div class="r-append-img adventure-pvp-icon"
                                  >
                        <img class="refresh-icon" [src]="
                          game?.gameData?.game_type_id == 13
                            ? 'assets/icon/refresh-3x.png'
                            : game?.gameData?.game_type_id == 14
                            ? 'assets/icon/users.svg'
                            : ''
                        " />
                                  </div>
                                }
                                <!-- <img src="assets/icon/refresh-3x.png" alt="refresh"  class="refresh-icon"> -->
                              </ion-col>
                              <ion-col size="6">
                                <div class="game-details">
                                  <div class="game-title">{{game?.gameData?.content?.[selectedLanguage]?.game_title }}</div>
                                  <div class="game-sub-title">{{ game?.game_short_title }}</div>
                                  <div class="player-count">
                                    <img src="../../../../assets/icon/member-icon.svg" class="player-icon" />
                                    <span class="play-count">{{ game?.count }}</span>
                                  </div>
                                </div>
                              </ion-col>
                              <ion-col class="prize" size="2" (click)="navigateToGamePage(game)">
                                <span class="prize-title">{{ "discovery.Prize" | translate }}</span>
                                <div class="prize-value">
                                  <span class="value  bg-{{ game?.gameData?.tier }}">{{ game?.top_prize }}</span>
                                </div>
                              </ion-col>
                            </ion-row>
                          }
                        </div>
                      </ng-template>
                    }
                  </swiper>
                </ion-row>
              </ion-card>
            }
            <!-- Games played by people users follow -->
            <!-- end -->
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-label" [ngClass]="{ 'game-subtab': currentTab === 1 }">{{
              "discovery.Discover" | translate
            }}</span>
          </ng-template>
          <div class="container">
            <!-- start -->
            @if (!card || !card?.friends_not_me || !card?.friends_not_me.length) {
              <ion-card class="trending-card">
                <div class="text-wrrper">
                  <ion-card-header>
                    <span class="tab-title">{{ "discovery.Games" | translate }}</span>
                    <ion-card-subtitle>
                      <p class="sub-title">{{ "discovery.Played" | translate }}</p>
                    </ion-card-subtitle>
                  </ion-card-header>
                </div>
                <!-- <ion-content> -->
                <div class="img-wrraper">
                  <img src="../../../../assets/icon/img-icon.svg" alt="" />
                  <span class="group-link">{{ "discovery.Make" | translate }} <a (click)="openCommnuityTab()">{{
                  "discovery.Group" | translate }}</a></span>
                </div>
              <!-- </ion-content> -->
            </ion-card>
          } @else {
            <ion-card class="trending-card">
              <div class="text-wrrper">
                <ion-card-header>
                  <span class="tab-title">{{ "discovery.Games" | translate }}</span>
                  <ion-card-subtitle>
                    <p class="sub-title">{{ "discovery.Played" | translate }}</p>
                  </ion-card-subtitle>
                </ion-card-header>
              </div>
              <ion-row class="game-slide-row">
                <swiper class="game-slider" [config]="slideOpts">
                  @for (data of card?.friends_not_me | filterYoursToPlay : 2; track data; let i = $index) {
                    <ng-template swiperSlide>
                      <div class="item-card-container">
                        @for (game of data; track game) {
                          <ion-row class="player-card">
                            <ion-col size="4" class="play-icon">
                              <img src="{{ game?.gameData?.game_icon_url }}" class="game-icon"
                                (click)="openGamePreview(game)" />
                                @if (game?.gameData?.game_type_id == 13 || game?.gameData?.game_type_id == 14) {
                                  <div class="r-append-img adventure-pvp-icon"
                                    >
                        <img class="refresh-icon" [src]="
                          game?.gameData?.game_type_id == 13
                            ? 'assets/icon/refresh-3x.png'
                            : game?.gameData?.game_type_id == 14
                            ? 'assets/icon/users.svg'
                            : ''
                        " />
                                    </div>
                                  }
                                  <!-- <img src="assets/icon/refresh-3x.png" alt="refresh"  class="refresh-icon"> -->
                                </ion-col>
                                <ion-col size="6">
                                  <div class="game-details">
                                    <div class="game-title">{{game?.gameData?.content?.[selectedLanguage]?.game_title }}</div>
                                    <div class="game-sub-title">{{ game?.game_short_title }}</div>
                                    <div class="player-count">
                                      <img src="../../../../assets/icon/member-icon.svg" class="player-icon" />
                                      <span class="play-count">{{ game?.count }}</span>
                                    </div>
                                  </div>
                                </ion-col>
                                <ion-col class="prize" size="2" (click)="navigateToGamePage(game)">
                                  <span class="prize-title">{{ "discovery.Prize" | translate }}</span>
                                  <div class="prize-value">
                                    <span class="value  bg-{{ game?.gameData?.tier }}">{{ game?.top_prize }}</span>
                                  </div>
                                </ion-col>
                              </ion-row>
                            }
                          </div>
                        </ng-template>
                      }
                    </swiper>
                  </ion-row>
                </ion-card>
              }
              <!-- END -->
              <!-- Vishal@pordiotracker Date 16-12-2022-->
              <!-- End Date:16-12-2022 -->
              <!-- If data Played by people you follow game are not available -->
              @if (!card || !card?.group_not_me || !card?.group_not_me.length) {
                <ion-card class="trending-card">
                  <div class="text-wrrper">
                    <ion-card-header>
                      <span class="tab-title">{{ "discovery.Games$" | translate }}</span>
                      <ion-card-subtitle>
                        <p class="sub-title">{{ "discovery.Played$" | translate }}</p>
                      </ion-card-subtitle>
                    </ion-card-header>
                  </div>
                  <!-- <ion-content> -->
                  <div class="img-wrraper">
                    <img src="../../../../assets/icon/img-icon.svg" alt="" />
                    <span class="group-link">{{ "discovery.Make" | translate }} <a (click)="openCommnuityTab()"> {{
                    "discovery.Group" | translate }}</a></span>
                  </div>
                <!-- </ion-content> -->
              </ion-card>
            } @else {
              <ion-card class="trending-card">
                <div class="text-wrrper">
                  <ion-card-header>
                    <span class="tab-title">{{ "discovery.Games$" | translate }}</span>
                    <ion-card-subtitle>
                      <p class="sub-title">{{ "discovery.Played$" | translate }}</p>
                    </ion-card-subtitle>
                  </ion-card-header>
                </div>
                <ion-row class="game-slide-row">
                  <swiper class="game-slider" [config]="slideOpts">
                    @for (data of card?.group_not_me | filterYoursToPlay : 2; track data; let i = $index) {
                      <ng-template swiperSlide>
                        <div class="item-card-container">
                          @for (game of data; track game) {
                            <ion-row class="player-card">
                              <ion-col size="4" class="play-icon">
                                <img src="{{ game?.gameData?.game_icon_url }}" class="game-icon"
                                  (click)="openGamePreview(game)" />
                                  @if (game?.gameData?.game_type_id == 13 || game?.gameData?.game_type_id == 14) {
                                    <div class="r-append-img adventure-pvp-icon"
                                      >
                        <img class="refresh-icon" [src]="
                          game?.gameData?.game_type_id == 13
                            ? 'assets/icon/refresh-3x.png'
                            : game?.gameData?.game_type_id == 14
                            ? 'assets/icon/users.svg'
                            : ''
                        " />
                                      </div>
                                    }
                                    <!-- <img src="assets/icon/refresh-3x.png" alt="refresh"  class="refresh-icon"> -->
                                  </ion-col>
                                  <ion-col size="6">
                                    <div class="game-details">
                                      <div class="game-title">{{game?.gameData?.content?.[selectedLanguage]?.game_title }}</div>
                                      <div class="game-sub-title">{{ game?.game_short_title }}</div>
                                      <div class="player-count">
                                        <img src="../../../../assets/icon/member-icon.svg" class="player-icon" />
                                        <span class="play-count">{{ game?.count }}</span>
                                      </div>
                                    </div>
                                  </ion-col>
                                  <ion-col class="prize" size="2" (click)="navigateToGamePage(game)">
                                    <span class="prize-title">{{ "discovery.Prize" | translate }}</span>
                                    <div class="prize-value">
                                      <span class="value  bg-{{ game?.gameData?.tier }}">{{ game?.top_prize }}</span>
                                    </div>
                                  </ion-col>
                                </ion-row>
                              }
                            </div>
                          </ng-template>
                        }
                      </swiper>
                    </ion-row>
                  </ion-card>
                }
                <!-- Games played by people users follow -->
                <!-- end -->
              </div>
            </mat-tab>
            <!-- Mission -->
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label" [ngClass]="{ 'game-subtab': currentTab === 2 }">{{
                  "missions.Missions" | translate
                }}</span>
              </ng-template>
              @if (getMissionData$ | async; as mission) {
                <div class="mission-container">
                  <ion-card class="missions-card">
                    <ion-card-header>
                      <span class="tab-title">{{ "missions.Missions" | translate }}</span>
                    </ion-card-header>
                    <swiper #gameMission class="mission-slide" [config]="cardSlide" (swiper)="onSlideChange(mission?.restData)"
                      (slideChange)="onSlideChange(mission?.restData)">
                      @for (one of mission?.restData; track one) {
                        <ng-template swiperSlide>
                          <div
                            [ngClass]="checkCards(one) == 'joinWithDisable' ? 'joinWithDisable-missions' : 'missions-card-container'">
                            <ion-row class="missions-card-row">
                              <ion-col class="missions-content" size="7">
                                <div>
                                  <!-- Content heading -->
                                  <h3 class=""
                                    [ngClass]="checkCards(one) == 'joinWithDisable' ? 'join-disable-title' : 'card-heading'">
                                  {{one?.eventData?.content?.[selectedLanguage]?.title}}</h3>
                                  <!-- Contaent <p>-->
                                  <span [ngClass]="checkCards(one) == 'joinWithDisable' ? 'disable-description' : 'card-sub-text'">
                      <span [ngClass]="{
                          'seperate-des': selectedLanguage != 'en',
                          'english-des': selectedLanguage === 'en'
                        }" class="common-span">
                                      {{one?.eventData?.content?.[selectedLanguage]?.description}}
                                    </span>
                                  </span>
                                  <!-- Button -->
                                  @if (checkCards(one) == 'completed') {
                                    <button class="completed-card-btn">
                                      {{ "missions.Completed" | translate }}
                                    </button>
                                  }
                                  <!-- <button *ngIf="getButtonText(mission?.restData?.[selectedCard]) == 'contributor'" class="completed-card-btn" (click)="startSpinner()">
                                  {{ "missions.Contribution" | translate}}
                                </button> -->
                                @if (checkCards(one) == 'join' && !spinnerAnimation) {
                                  <button
                                    [ngClass]="(getButtonText(one)|async) == 'Join' ? 'join-mission-btn': 'completed-card-btn' "
                                    [disabled]="userAlreadyJoined" (click)="JoinMission(); startSpinner()">
                                    {{getButtonText(one)|async}}
                                  </button>
                                }
                                @if (checkCards(one) == 'join' && spinnerAnimation) {
                                  <div class="spinners"
                                    [ngClass]="{ 'bg-v': checkCards(one) == 'join' }" class="join-btn ">
                                    <mat-progress-spinner mode="determinate" [value]="progressBar" class="track-spinner"
                                      diameter="30">
                                    </mat-progress-spinner>
                                  </div>
                                }
                                @if (checkCards(one) == 'joinWithDisable') {
                                  <button [disabled]="isDisable" class="join-btn"
                                    (click)="JoinMission()">
                                    {{ "missions.Join" | translate }}
                                  </button>
                                }
                              </div>
                            </ion-col>
                            <ion-col class="missions-progress-box" size="5">
                              <!-- Progressbar -->
                              <div class="progress-block">
                                <div class="progress-title">
                                  <img src="../../../../assets/icon/champ.svg" alt="champ" class="img-1" />
                                  @if (checkCards(one) == 'completed') {
                                    <span class="img-title">{{ "missions.Complete!" | translate
                                    }}</span>
                                  }
                                  @if (checkCards(one) == 'join') {
                                    <span class="img-title">
                                      <app-count-down-timer class="remaining-time" end="{{ one.end.seconds }}" type="seconds">
                                      </app-count-down-timer>
                                    </span>
                                  }
                                  @if (checkCards(one) == 'joinWithDisable') {
                                    <span class="img-title">{{ "missions.Starts" |
                                    translate }} {{ getweeks(one?.start) }}!</span>
                                  }
                                </div>
                                <div class="progress-section">
                                  <div class="progress-bar">
                                    <span class="inner-value">{{ one?.target }}</span>
                                    @if (getPercent(one?.current_achieved, one?.eventData?.target) != '0') {
                                      <div class="progress"
                          [ngStyle]="{
                          'width.%': getPercent(one?.current_achieved, one?.eventData?.target) >= 100 ? 100 : (one?.current_achieved / one?.eventData?.target * 100),
                          background: 'linear-gradient(184.42deg, #FFAB3B 21.36%, #FFD100 97.33%)'
                        }">
                                        @if (one?.current_achieved != '0') {
                                          <span
                                            [ngClass]="getPercent(one?.current_achieved, one?.eventData?.target) == 100 ? 'percent-value-complete' : 'percent-value'">{{
                                          one?.current_achieved }}</span>
                                        }
                                      </div>
                                    }
                                  </div>
                                  <div class="progress-lott-box">
                                    <div class="lott-box">
                                      <img src="../../../../assets/icon/chest_31.svg" alt="champ" class="img-2" />
                                    </div>
                                  </div>
                                  @if (checkCards(one) == 'joinWithDisable') {
                                    <div class="progress-lott-box">
                                      <div class="lott-box">
                                        <img src="../../../../assets/icon/chest_disable.svg" alt="champ" class="img-2" />
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                              <!-- Lootbox image -->
                            </ion-col>
                          </ion-row>
                        </div>
                      </ng-template>
                    }
                  </swiper>
                  <!-- Start No Contributesers -->
                  <!-- Start -->
                  @if (!mission?.restData?.[selectedCard]?.leaderBoardData || !mission?.restData?.[selectedCard]?.leaderBoardData.length ) {
                    <ion-card class="no-missions-Contributors">
                      <ion-card-header class="title">
                        <div class="heading">
                <span class="card-title" [ngClass]="{
                  'contributors-de': selectedLanguage == 'de',
                  'contributors-en':selectedLanguage == 'en',
                  'contributors-it': selectedLanguage == 'it',
                  'contributors-es': selectedLanguage == 'es',
                  'contributors-fr': selectedLanguage == 'fr'
                }">{{ "missions.Contributors" | translate }}</span>
                          <span class="current-rank">{{ "missions.current_ranking" | translate }}</span>
                        </div>
                        <ion-card-subtitle class="sub-title">{{ "missions.Team_Challenge" | translate }} </ion-card-subtitle>
                      </ion-card-header>
                      <ng-container>
                        <div class="contributors-empty-wrapper">
                          <div class="empty-data">
                            <img src="../../../../assets/icon/image-outline.svg" alt="">
                            <p (click)="JoinMission()"> {{ "missions.Contributors_yet" | translate }}
                              <br>
                                @if (checkCards(mission?.restData?.[selectedCard]) == 'join'&& !spinnerAnimation) {
                                  <a
                                  (click)="JoinMission(); startSpinner()">{{ "missions.the_Frist" | translate }} </a>
                                }
                              </p>
                            </div>
                          </div>
                        </ng-container>
                      </ion-card>
                    } @else {
                      <ion-card class="missions-Contributors">
                        <!-- Mission List title -->
                        <ion-card-header class="title">
                          <div class="heading">
                            <span class="card-title">{{ "missions.Contributors" | translate }}</span>
                            @if (getRank(mission?.restData?.[selectedCard]?.leaderBoardData) !== null) {
                              <div>
                                <span class="current-rank">
                                  {{ "missions.ranking" | translate }}
                                  {{ getRank(mission?.restData?.[selectedCard]?.leaderBoardData) }}
                                </span>
                              </div>
                            }
                            @if (getRank(mission?.restData?.[selectedCard]?.leaderBoardData) === null) {
                              <div>
                                <span class="current-rank">
                                  {{ "missions.current_ranking" | translate }}
                                </span>
                              </div>
                            }
                          </div>
                          <ion-card-subtitle class="sub-title">{{ "missions.Team_Challenge" | translate }} </ion-card-subtitle>
                        </ion-card-header>
                        <!-- List Wrapper -->
                        <ion-card-content class="contibute-tab">
                          <div class="tab-wrapper">
                            @for (listOne of mission?.restData?.[selectedCard]?.leaderBoardData; track listOne; let i = $index) {
                              <ion-row class="contribute-list" [ngClass]="i === 3 || i === 10  ? 'list-margin' : 'contribute-list'">
                                <ion-col size="1">
                                  <p class="index-value">{{ i + 1 }}</p>
                                </ion-col>
                                <ion-col size="9" class="contributer">
                                  <div class="game-profile">
                                    <img src="{{ listOne?.profile_picture }}" alt="contribute.png" />
                                  </div>
                                  <div class="contribute-game">
                                    <span>{{ listOne?.profile_nickname }}</span>
                                    <div class="game-value">
                                      <img src="../../../../assets/icon/yellow.png" alt="" />
                                      <span>{{ listOne?.gxp }} </span>&nbsp;
                                      <!-- <span *ngIf="i < 3"> {{ "missions.Contribution" | translate}}</span> -->
                                    </div>
                                  </div>
                                </ion-col>
                                <ion-col size="2" class="lott-box">
                                  <!-- <img src="../../../../assets/icon/lott-box-1.svg" alt="" /> -->
                                  @if (i < 3) {
                                    <img src="../../../../assets/icon/box1.svg" alt="">
                                  }
                                  @if (i >= 3) {
                                    <img src="../../../../assets/icon/box2.svg" alt="">
                                  }
                                </ion-col>
                              </ion-row>
                            }
                          </div>
                          <br />
                        </ion-card-content>
                      </ion-card>
                    }
                    <!-- End -->
                    <!--Mission Contibutour List -->
                    <!-- Start -->
                  </ion-card>
                </div>
              } @else {
                @if (currentTab === 0) {
                  <div>
                    <app-in-progress-animation type="trending"></app-in-progress-animation>
                  </div>
                }
                @if (currentTab === 1) {
                  <div>
                    <app-in-progress-animation type="trending"></app-in-progress-animation>
                  </div>
                }
                @if (currentTab === 2) {
                  <div>
                    <app-in-progress-animation type="missions-cards-skeleton"></app-in-progress-animation>
                  </div>
                }
                @if (currentTab === 3) {
                  <div>
                    <app-in-progress-animation type="leaderboard"></app-in-progress-animation>
                  </div>
                }
              }
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <span class="tab-label" [ngClass]="{ 'game-subtab': currentTab === 3 }"><span
                [ngClass]="spanish == true ? 'spanish' : ''">{{ "leaderboard.Leaderboard" | translate }}</span></span>
              </ng-template>
              <app-games-leaderboard></app-games-leaderboard>
            </mat-tab>
          </mat-tab-group>
        } @else {
          @if (currentTab === 0) {
            <div>
              <app-in-progress-animation type="trending"></app-in-progress-animation>
            </div>
          }
          @if (currentTab === 1) {
            <div>
              <app-in-progress-animation type="trending"></app-in-progress-animation>
            </div>
          }
          @if (currentTab === 2) {
            <div>
              <app-in-progress-animation type="missions-cards-skeleton"></app-in-progress-animation>
            </div>
          }
          @if (currentTab === 3) {
            <div>
              <app-in-progress-animation type="leaderboard"></app-in-progress-animation>
            </div>
          }
        }

        <!-- Discover tab -->

        <!-- Vishal@pordiotracker Date:17-12-2022 -->
        <!-- Missions tab -->

        <!-- End -->

        <!-- Leaderboard tab-->
